// extracted by mini-css-extract-plugin
export default {"root":"o7pKw0","header-cell":"I43Xs0","headerCell":"I43Xs0","priceContainer":"F6cLy0","cta":"NUNh9I","anonymous":"oqDrOC","tax":"gdRLi_"};